<template>
    <div class="website-buttons">
        <d-btn :class="{ 'ml-2 active': 'total' === isActive, 'ml-2 btn-white': 'total' !== isActive }" @click="resetFilter()">Total</d-btn>
        <d-btn v-for="item in websites" :class="{ 'ml-2 active': item.id === isActive, 'ml-2 btn-white': item.id !== isActive }" @click="filterDashboardData(item.id)">{{ item.domain }}</d-btn>
    </div>
</template>

<script>
    import loader from '@/mixins/loader';
    import { SummaryService, TransactionService } from '@/main';
    import DateHelper from '@/helpers/date';
    import * as Sentry from "@sentry/browser";

    export default {
        props: ['websites', 'updateTransactionBlocks', 'resetDashboardData', 'graph'],

        mixins: [loader],

        data() {
            return {
                isActive: 'total',
            }
        },

        methods: {
            async resetFilter() {
                let filterLoader = this.showLoader()
                try {
                    this.isActive = 'total'
                    const affiliateInfo = await SummaryService.getSummaryTransactions(DateHelper.getFirstDayCurrentMonth(), DateHelper.getDateToday(), '')

                    this.resetDashboardData(affiliateInfo)

                    filterLoader.hide()
                } catch(err) {
                    filterLoader.hide()
                    Sentry.captureException(err)
                    Sentry.captureMessage('summary service get summary transactions (Reset filter) error')
                }
            },

            async filterDashboardData(websiteId) {
                let filterLoader = this.showLoader()
                try {
                    this.isActive = websiteId
                    const summaryToday = await SummaryService.getByWebsite(DateHelper.getDateToday(), DateHelper.getDateToday(), websiteId)
                    const summaryYesterday = await SummaryService.getByWebsite(DateHelper.getDateYesterday(), DateHelper.getDateToday(), websiteId)
                    const summaryCurrentMonth = await SummaryService.getByWebsite(DateHelper.getDateThisMonth(), DateHelper.getMonthEnd(), websiteId)
                    const summaryLastMonth = await SummaryService.getByWebsite(DateHelper.getLastMonthStart(), DateHelper.getLastMonthEnd(), websiteId)

                    const affiliateInfo = await SummaryService.getSummaryTransactions(DateHelper.getFirstDayCurrentMonth(), DateHelper.getDateToday(), websiteId)

                    this.updateTransactionBlocks(websiteId, summaryToday, summaryYesterday, summaryCurrentMonth, summaryLastMonth)
                    this.graph.update(affiliateInfo)

                    filterLoader.hide()
                } catch(err) {
                    filterLoader.hide()
                    Sentry.captureException(err)
                    Sentry.captureMessage('Summary service get Summary transaction (filter Dashboard Data) error')
                }
            }
        }
    }
</script>
